export function getStrDate(fecha, flg) {
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  const diasSemana = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];

  return `${
    diasSemana[fecha.getDay()] +
    " " +
    fecha.getDate() +
    ", " +
    meses[fecha.getMonth()] +
    " " + (flg ?
    fecha.getFullYear() : "")
  }`;
}

export function getStrDateYear(fecha) { 

  const meses = [
    "ENE",
    "FEB",
    "MAR",
    "ABR",
    "MAY",
    "JUN",
    "JUL",
    "AGO",
    "SEP",
    "OCT",
    "NOV",
    "DIC",
  ];

  return `${fecha.getDate() + " de " + meses[fecha.getMonth()] + ", " + fecha.getFullYear()}`;
}
